module.exports = __webpack_public_path__ + "static/media/3_col_1.2dee8067.jpg";